export default "__VITE_ASSET__CaXVJSfu__"